<script setup>
import { ref } from 'vue';

defineProps({
  hours: {
    type: Object,
    required: true
  }
});

const open = ref(false);

function toggle() {
  open.value = !open.value;
}

function close() {
  open.value = false;
}
</script>

<template>
  <div class="vsb-hours" @keydown.escape="close">
    <button
      type="button"
      class="vsb-hours__trigger"
      :aria-expanded="open"
      aria-haspopup="dialog"
      @click="toggle"
    >
      <span class="vsb-hours__icon" aria-hidden="true">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      </span>
      <span class="vsb-hours__text">
        <span class="vsb-hours__title">{{ hours.label }}</span>
        <span class="vsb-hours__sub">{{ hours.phoneHours }}</span>
      </span>
    </button>

    <div v-if="open" class="vsb-hours__backdrop" @click="close" />
    <div v-if="open" class="vsb-hours__panel" role="dialog" aria-label="Openingstijden">
      <p class="vsb-hours__panel-label">{{ hours.label }}</p>
      <p v-if="hours.announcement" class="vsb-hours__announce">{{ hours.announcement }}</p>
      <dl class="vsb-hours__list">
        <div>
          <dt>Beesd</dt>
          <dd>{{ hours.beesd }}</dd>
        </div>
        <div>
          <dt>Culemborg</dt>
          <dd>{{ hours.culemborg }}</dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<style scoped>
.vsb-hours {
  position: relative;
}

.vsb-hours__trigger {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  border-radius: 6px;
  transition: background 0.2s;
}

.vsb-hours__trigger:hover {
  background: var(--vsb-blue-subtle, #f7fafe);
}

.vsb-hours__trigger:hover .vsb-hours__title {
  color: var(--vsb-blue-mid, #1456b8);
}

.vsb-hours__icon {
  color: var(--vsb-blue-dark, #0b3d91);
  flex-shrink: 0;
}

.vsb-hours__text {
  display: flex;
  flex-direction: column;
  line-height: 1.25;
}

.vsb-hours__title {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--vsb-blue-dark, #0b3d91);
  transition: color 0.2s;
}

.vsb-hours__sub {
  font-size: 0.6875rem;
  color: var(--vsb-muted, #64748b);
}

.vsb-hours__backdrop {
  position: fixed;
  inset: 0;
  z-index: 9998;
}

.vsb-hours__panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  z-index: 9999;
  min-width: 220px;
  padding: 1rem 1.125rem;
  background: var(--vsb-blue-subtle, #f7fafe);
  border: 1px solid #dce8f4;
  border-radius: 10px;
  box-shadow: 0 12px 32px rgba(11, 61, 145, 0.12);
}

.vsb-hours__panel-label {
  margin: 0 0 0.5rem;
  font-size: 0.8125rem;
  font-weight: 700;
  color: var(--vsb-blue-dark, #0b3d91);
}

.vsb-hours__announce {
  margin: 0 0 0.75rem;
  font-size: 0.75rem;
  color: var(--vsb-muted, #64748b);
}

.vsb-hours__list {
  margin: 0;
}

.vsb-hours__list div {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  padding: 0.35rem 0;
  font-size: 0.8125rem;
  border-top: 1px solid #f1f5f9;
}

.vsb-hours__list div:first-child {
  border-top: none;
}

.vsb-hours__list dt {
  font-weight: 600;
  color: #334155;
}

.vsb-hours__list dd {
  margin: 0;
  color: var(--vsb-muted, #64748b);
}
</style>
